import * as React from 'react';
import Offcanvas from '../../../faceted-search/react/Offcanvas';
import { FilterButton } from '../../../faceted-search/react/helper';
import { SearchProvider } from '@elastic/react-search-ui';
import SearchRoot from '../SearchRoot';
import { hiddenFacets, providerConfig } from '../../helper';
import {
  OpenSearchActiveFilters,
  OpenSearchClearAllFiltersButton,
  OpenSearchItemsPerPage,
  OpenSearchPagination,
  OpenSearchResultsCount,
  OpenSearchSearchBox,
  OpenSearchStats
} from '../components';
import { SearchResult } from '../search-results';
import { StandardLayoutFilters } from './index';

export default function StandardLayout(props) {
  const {
    connector,
    config = {},
    css = {},
    trackUrlState = true,
  } = props;
  const {displayOptions, ViewMode} = config;
  const {itemsPerPage} = displayOptions;

  const hiddenFacetsList = React.useMemo(() => hiddenFacets(config?.facets), [config?.facets]);

  return (
    <div className={css?.root}>
      <SearchProvider config={{...providerConfig(config), apiConnector: connector, trackUrlState: trackUrlState}}>
        <SearchRoot>
          <Offcanvas title={'Filters'} callback={() => {document.querySelector('.nv-open-search button.clear-filters')?.click();}}>
            <StandardLayoutFilters facets={config?.facets} sorting={config?.sorting}/>
          </Offcanvas>
          <div className='row'>
            <div className='col-lg-3 col-md-12 col-sm-12 col--filters'>
              <div className='mobile-filters-block'>
                <OpenSearchSearchBox/>
                <div className='mobile-filters-switcher'>
                  <FilterButton/>
                </div>
              </div>

              <StandardLayoutFilters facets={config?.facets} sorting={config?.sorting}/>
            </div>
            <div className='col-lg-9 col-md-12 col-sm-12'>
              <div className='search-stats'>
                <div className='search-stats__counter d-flex align-items-center'>
                  <OpenSearchStats/>
                </div>
                <div className='pager'>
                  <OpenSearchPagination/>
                </div>
              </div>

              <div className='active-filters-panel'>
                <OpenSearchClearAllFiltersButton/>
                <OpenSearchActiveFilters facets={config?.facets} hiddenFacets={hiddenFacetsList}/>
              </div>

              <SearchResult viewMode={ViewMode}/>

              <div className='row search-stats__footer'>
                <div className='col-lg-4 col-sm-12 d-flex align-items-center justify-content-start footer-col'>
                  <OpenSearchItemsPerPage itemsPerPage={itemsPerPage}/>
                </div>
                <div className='col-lg-4 col-sm-12 d-flex align-items-center justify-content-center footer-col'>
                  <OpenSearchResultsCount/>
                </div>
                <div className='col-lg-4 col-sm-12 footer-col'>
                  <OpenSearchPagination/>
                </div>
              </div>
            </div>
          </div>
        </SearchRoot>
      </SearchProvider>
    </div>
  );
}
